import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getSteamStats } from '@intelligence/services/topcharts';
import { financeFormat, ratioValueFormat } from '@/pages/home/utils/common';
interface Iprops {
  steamDateType: 'week' | 'day' | 'month';
  gameId: string;
  idList: any[];
}
const FORMAT_WORD = 'YYYY-MM-DD HH:mm:ss';
const reviewType = {
  positive: {
    color: '#69d19c',
    text: 'dbi_top_positive',
    width: '0',
    value: 0,
    icon: 'good-icon',
    tipsMap: 'dbi_top_positive',
  },
  negative: {
    color: '#f17c86',
    text: 'dbi_top_negative',
    width: '0',
    value: 0,
    icon: 'no-good-icon',
    tipsMap: 'dbi_top_negative',
  },
};
const SteamLineHooks = (props: Iprops) => {
  const { steamDateType, gameId, idList = [] } = props;
  const [steamLineList, setSteamLineList] = useState([reviewType.positive, reviewType.negative]);
  const [reviewName, setReviewName] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isEmpty, setIsEmpty] = useState(true);
  const now = moment();
  const setDateType = function () {
    // const today = now.format(FORMAT_WORD);
    // if (steamDateType == 'day') return [today, today];
    const type = steamDateType == 'week' ? 'isoWeek' : steamDateType;
    const startTime = now.clone().startOf(type).format(FORMAT_WORD);
    const endTime = now.clone().endOf(type).format(FORMAT_WORD);
    return [startTime, endTime];
  };
  const dateType = setDateType() || [];

  const initSteamLineListData = async () => {
    try {
      const params = {
        edition_unified_id: idList[0]?.id,
        entity_type: 'pc',
        id_type: 'edition_id',
        start_time: dateType[0],
        end_time: dateType[1],
        date_type: 'daily',
      };
      setIsLoading(true);
      const res = await getSteamStats(params);
      // eslint-disable-next-line @typescript-eslint/naming-convention
      if (!res?.all_reviews || !res?.all_reviews?.review) {
        setIsEmpty(true);
        return;
      }
      const { all_reviews = {} } = res || {};
      const { review, score, name = '' } = all_reviews;
      setReviewName(name);
      const positiveValue = Math.round(review * score);
      const negativeValue = review - positiveValue;
      const negativeScore = 1 - score;
      const newSteamList: any = [
        {
          ...reviewType.positive,
          width: ratioValueFormat(score, 2, false, '', false, 3),
          value: financeFormat(positiveValue, 2, false, ''),
        },
        {
          ...reviewType.negative,
          width: ratioValueFormat(negativeScore, 2, false, '', false, 3),
          value: financeFormat(negativeValue, 2, false, ''),
        },
      ];
      setSteamLineList(newSteamList);
      setIsEmpty(false);
    } catch (error) {
      setIsEmpty(true);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (idList?.length) {
      initSteamLineListData();
    }
  }, [JSON.stringify(idList)]);
  return {
    isLoading,
    steamLineList,
    isEmpty,
    reviewName,
  };
};

export default SteamLineHooks;
